import { svg } from "./dom";

/**
 * The stick figure. The frame is always there; each wrong letter adds a part, in this
 * order: head, body, left arm, right arm, left leg, right leg and, for phrases (which
 * allow one more miss), a hat.
 */
export class Figure {
  readonly el: SVGSVGElement;
  private readonly parts: SVGElement[];
  private readonly face: SVGElement;

  constructor() {
    this.el = svg("svg", { viewBox: "0 0 200 220", class: "figure", role: "img" });
    const frame = svg("path", {
      d: "M20 205h110 M50 205V20h80v24 M50 60l34-40",
      class: "figure-frame",
    });
    const line = (d: string) => svg("path", { d, class: "figure-part" });
    const head = svg("circle", { cx: 130, cy: 66, r: 22, class: "figure-part figure-head" });
    this.parts = [
      head,
      line("M130 88v56"),
      line("M130 102l-26 24"),
      line("M130 102l26 24"),
      line("M130 144l-22 38"),
      line("M130 144l22 38"),
      // Hat: brim and crown.
      line("M104 48h52 M114 48v-16h32v16"),
    ];
    // Eyes and a mouth that turns from a smile into a worried line as misses add up.
    this.face = svg("path", { d: "", class: "figure-face" });
    this.el.append(frame, ...this.parts, this.face);
    this.set(0, 6, "");
  }

  /** Shows the first `misses` parts. `max` decides whether the last one (the hat) can appear. */
  set(misses: number, max: number, label: string): void {
    this.parts.forEach((part, i) => {
      const shown = i < misses && i < max;
      part.classList.toggle("is-shown", shown);
    });
    const worried = misses >= max - 1;
    const lost = misses >= max;
    const eyes = lost ? "M120 60l6 6m0-6l-6 6 M134 60l6 6m0-6l-6 6" : "M123 62v2 M137 62v2";
    const mouth = lost ? "M122 78q8-7 16 0" : worried ? "M123 76h14" : "M122 73q8 7 16 0";
    this.face.setAttribute("d", `${eyes} ${mouth}`);
    this.face.classList.toggle("is-shown", misses > 0);
    this.el.setAttribute("aria-label", label);
  }
}
